<template>
  <div>
    <div id="mt-swipe">
      <!-- <mt-swipe :auto="3000" :show-indicators="true">
        <mt-swipe-item v-for="item in imgUrls" :key="item">
          <img :src="item" class="banner-image" />
        </mt-swipe-item>
      </mt-swipe> -->
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide v-for="item in imgUrls" :key="item">
          <img :src="item" class="banner-image" />
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="button-container">
      <div id="button" :class="`bg_${platformInfo.skin} br_${platformInfo.skin}`" @click="goBack">
        <img src="../assets/tutorial_btn_photo.png" id="photo-icon" />
        <span>我知道了，去拍证件照</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css'
export default {
  data() {
    return {
      imgUrls: [],
      swiperOption: {
        pagination: {
          el: '.swiper-pagination'
        },
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },
        loop: true
      }
    };
  },
  components:{swiper,swiperSlide},
  computed: {
    ...mapState(["platformInfo", "skintheme"])
  },
  activated() {
	  this.getTutorial()
  },
  methods: {
	...mapActions(['getGuide']),
    goBack() {
      this.$router.go(-1);
	},
	getTutorial() {
    let highFlag = document.documentElement.clientHeight > 614;
		console.log(`屏幕为${highFlag}`)
		this.getGuide().then(res => {
			let data = res.data;
			let xingshi = highFlag ? "GuideLong" : "GuideShort";
			this.imgUrls = data[this.skintheme[this.platformInfo.skin]][xingshi]
		})
	}
  }
};
</script>

<style>
#mt-swipe {
  width: 100%;
}
#mt-swipe .mint-swipe {
  position: initial;
  height: auto;
}
#mt-swipe .mint-swipe-items-wrap {
  position: initial;
  height: auto;
}
.banner-image {
  width: 100%;
}
#button {
  width: 94.667vw;
  height: 0.45rem;
  /* background:rgba(68,128,231,1); */
  box-shadow: 0px 0.05rem 0.1rem 0px rgba(68, 128, 231, 0.25);
  /* border-radius:0.225rem; */
  line-height: 0.45rem;
  color: white;
  font-size: 0.16rem;
  display: flex;
  align-items: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
#photo-icon {
  width: 0.19rem;
  height: 0.16rem;
  margin-left: 0.9rem;
  margin-right: 0.13rem;
}
</style>
